<div class="container">
  <img [src]="logoPath" class="logo" />
  <div class="buttons">
    <button
      data-testid="login-button"
      [disabled]="isLoading()"
      mat-raised-button
      color="primary"
      (click)="login()"
    >
      Login
    </button>
    <a
      *ngIf="signUpOption"
      [disabled]="isLoading()"
      mat-raised-button
      color="primary"
      [routerLink]="signUpUrl"
    >
      Sign Up
    </a>
  </div>
  <mat-progress-bar
    *ngIf="isLoading()"
    mode="indeterminate"
    color="accent"
  ></mat-progress-bar>
</div>
